import { ROLE_VIEW } from '@/fixtures'

export default {
  path: 'user-role-permission',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'User Role & Permission',
      component: () => import('@/views/menus/UserRolePermission/Index'),
      meta: {
        permission: ROLE_VIEW
      }
    }
  ]
}
